<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M16.36,3.08H12.64L10,5.69,7.36,3.08H3.64L1,5.69V9.37l7.14,7.55h3.72L19,9.37V5.69Z"
      fill="currentColor"
    />
  </svg>
</template>
